module.exports = __webpack_public_path__ + "whiteclothing.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whiteclothing.png
// module id = 885
// module chunks = 0